const MusterError = require('./muster-error');

/**
 * typedef MusterErrorObject
 * @property {MusterErrorCode} code Muster error code
 * @property {string} path Graph path
 * @property {RoutePattern|Array<RoutePattern>} route Handler route pattern
 * @property {string} method Graph operation method (`"get"`, `"set"`, or `"call"`)
 * @property {string} message Graph operation method (`"get"`, `"set"`, or `"call"`)
 */

/**
 * Return an error object
 * @param {MusterError} value Error to serialise
 * @returns {{$type: string, value: MusterErrorObject}} - the error object
 */
function error(value) {
  if (!value || !((typeof value === 'string') || (value instanceof Error))) {
      throw new Error(`Invalid error: ${value}`);
  }
  if (value instanceof MusterError) {
    return {
      $type: 'error',
      value: {
        message: value.message,
        code: value.code,
        path: value.path,
        route: value.route,
        method: value.method,
        stack: undefined,
      },
    };
  } else if (value instanceof Error) {
    return {
      $type: 'error',
      value: {
        code: MusterError.HANDLER_ERROR,
        message: value.message,
      },
    };
  }
  return {
    $type: 'error',
    value: {
      code: MusterError.HANDLER_ERROR,
      message: value,
    },
  };
}

module.exports = error;
